import { type NavigationTabItem, NavigationTabs } from '@exam-management/components';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import { usePermission } from '@shared/permissions';
import { useMemo } from 'react';

const TAB_LIST: NavigationTabItem[] = [
  {
    value: 'Overview',
    label: 'QConfig Overview',
    path: '/exam-courses/:courseId/qconfigs/:qconfigId',
    requiredPermission: [APP_PERMISSIONS.EXAM.QCONFIG.VIEW],
  },
  {
    value: 'Setting',
    label: 'QConfig Settings',
    path: '/exam-courses/:courseId/qconfigs/:qconfigId/settings',
    requiredPermission: [APP_PERMISSIONS.EXAM.QCONFIG.VIEW],
  },
  {
    value: 'ActivityLog',
    label: 'Activity Log',
    path: '/exam-courses/:courseId/qconfigs/:qconfigId/activity-log',
    requiredPermission: [APP_PERMISSIONS.EXAM.AUDIT_LOG.VIEW],
  },
];

export default function QConfigNavigationTabs() {
  const { permissions } = usePermission();
  const tabList = useMemo(
    () =>
      TAB_LIST.filter(
        (tab) =>
          !tab.requiredPermission ||
          tab.requiredPermission.every((permission) => permissions.includes(permission)),
      ),
    [permissions],
  );

  return <NavigationTabs items={tabList} navigateOptions={{ replace: true }} />;
}
